export default __webpack_public_path__ + "static/media/spacing-left.25806d51.svg";